import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import {
  MultiChannelOrderItemsUpdateStatusRequestBodyDto,
  MultiChannelOrderItemsUpdateStatusResponseDto,
} from '../../../types/api/multi-channels';
import MultiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';

const useUpdateMultiChannelOrderStatus = (): UseMutationResult<
  MultiChannelOrderItemsUpdateStatusResponseDto,
  AxiosError<unknown, unknown>,
  MultiChannelOrderItemsUpdateStatusRequestBodyDto,
  unknown
> => {
  return useMutation<
    MultiChannelOrderItemsUpdateStatusResponseDto,
    AxiosError,
    MultiChannelOrderItemsUpdateStatusRequestBodyDto
  >((payload: MultiChannelOrderItemsUpdateStatusRequestBodyDto) =>
    MultiChannelApi.updateMultiChannelOrderStatus(payload),
  );
};

export default useUpdateMultiChannelOrderStatus;
